export enum RestrictionTransitionColorEnum {
    REQ_REMOVE = 'danger',
    REQ_CONFIRM = "success",
    REQ_ADDNOTE = 'warning',
    REQ_ACCEPT = 'success',
    REQ_APPROVE = 'success',
    REQ_BLOCK = 'orangered'
}